import mix from '@utils/styles/mix'
import styles from 'styles/Icon.module.css'

const Icon = ({ className, children, ...rest }) => {
    const _className = mix(['material-icons', styles.i, className])
    return <i className={_className} {...rest}>{ children }</i>
}

export default Icon